import { findReadableBlock, isExcludedNode } from '../utils/dom';

export default class BionicReading {
  constructor() {
    this.active = false;
  }

  enable() {
    if (this.active) return;
    this.active = true;

    const isMobileViewport = window.matchMedia('(max-width: 768px)').matches;

    const walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, {
      acceptNode: (node) => {
        if (!node.nodeValue || !node.nodeValue.trim()) return NodeFilter.FILTER_REJECT;
        if (isExcludedNode(node)) return NodeFilter.FILTER_REJECT;
        if (isMobileViewport && this.isMobileExcludedNode(node)) return NodeFilter.FILTER_REJECT;
        return NodeFilter.FILTER_ACCEPT;
      },
    });

    const nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);

    const boldRatio = isMobileViewport ? 0.3 : 0.4;
    const maxBoldCount = isMobileViewport ? 2 : 3;

    nodes.forEach((node) => {
      const parts = node.nodeValue.split(/(\s+)/);
      const fragment = document.createDocumentFragment();

      parts.forEach((part) => {
        if (!part) return;
        if (/^\s+$/.test(part)) {
          fragment.appendChild(document.createTextNode(part));
          return;
        }
        const span = document.createElement('span');
        span.className = 'a11y-bionic-word';
        const boldCount = Math.max(1, Math.min(maxBoldCount, Math.ceil(part.length * boldRatio)));
        const strong = document.createElement('strong');
        strong.textContent = part.slice(0, boldCount);
        span.appendChild(strong);
        span.appendChild(document.createTextNode(part.slice(boldCount)));
        fragment.appendChild(span);
      });

      node.parentNode.replaceChild(fragment, node);
    });
  }

  isMobileExcludedNode(node) {
    const parent = node.parentElement;
    if (!parent) return true;

    if (parent.closest('button, a, nav, header, footer, .header, .navbar, .nav, .menu, .breadcrumb, .topbar')) {
      return true;
    }

    return !findReadableBlock(parent);
  }

  disable() {
    if (!this.active) return;
    document.querySelectorAll('.a11y-bionic-word').forEach((el) => {
      el.replaceWith(document.createTextNode(el.textContent));
    });
    document.body.normalize();
    this.active = false;
  }
}
